<template>
  <b-container fluid>
    <b-card title="Filter Dashboard">
      <b-row>
        <b-col md="12">
          <date-range-card :date="date" @filter-date="LoadDashboard"  @export="ExportDashboard"  />
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col md="12">
        <b-card title="Additional Information">
          <div class="text-center text-danger my-2" v-if="loadingDashboard">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
          <additional-info v-if="!loadingDashboard && countDocument && Object.keys(countDocument).length > 0"
            :countDocument="countDocument"/>
        </b-card>
      </b-col>
      <b-col cols="12" lg="4">
        <b-card>
          <div class="text-center text-danger my-2" v-if="loadingDashboard">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
          <top-division v-if="!loadingDashboard && topDivision && topDivision.length > 0"
            :topDivision="topDivision"/>
        </b-card>
      </b-col>
      <b-col cols="12" lg="4">
        <b-card>
          <div class="text-center text-danger my-2" v-if="loadingDashboard">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
          <top-product v-if="!loadingDashboard && topProduct && topProduct.length > 0"
            :topProduct="topProduct"/>
        </b-card>
      </b-col>
      <b-col cols="12" lg="4">
        <b-card>
          <div class="text-center text-danger my-2" v-if="loadingDashboard">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
          <top-project-status v-if="!loadingDashboard && topProjectStatus && topProjectStatus.length > 0"
            :topProjectStatus="topProjectStatus"/>
        </b-card>
      </b-col>
    </b-row>
    <b-card>
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0 col-md-6 col-12 p-0 m-0"
          >
          <ul class="nav nav-pills" style="margin-left:-20px;">
            <li class="nav-item" v-for="status in statuses" :key="status.value">
              <a
                class="nav-link"
                :class="{ active: currentStatus === status.value }"
                href="#"
                @click.prevent="filterByStatus(status.value)"
              >
                {{ status.label }}
              </a>
            </li>
          </ul>
          </b-col>
        </b-row>
      </div>
      <b-row class="align-items-center mb-1 mb-md-0">
        <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <label class="mb-0 mr-1">Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mr-1"
            style="width: 80px;" 
          />
  
          <b-button variant="primary" @click="ExportExcel()">Export</b-button>
        </b-col>
        <b-col cols="12" md="6" class="d-flex align-items-center justify-content-end">
          <label class="mb-0 mr-1">Search</label>
          <b-form-input
            v-model="searchWord"
            placeholder="Search..."
            class="w-100 w-md-auto mb-2"
            style="max-width: 200px;"
          />
        </b-col>
      </b-row>
      <!-- Larger screen than mobile -->
      <div class="d-none d-md-flex">
        <b-table 
          responsive
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items="filteredReservations"
          :fields="tableFields"
          :no-local-sorting="true"
          @sort-changed="sortingChanged"
          :busy="isBusy"
          class="w-100"
        >
          <template #cell(action)="row">
            <div class="d-flex justify-content-center align-items-center text-center">
              <b-button
                type="button"
                class="mr-1 txt-xs-2"
                size="sm"
                variant="secondary"
                @click="SetStatus(row.item)"
              >
                <feather-icon size="14" icon="BookIcon" />
              </b-button>
              <b-button
                type="button"
                class="mr-1 txt-xs-2"
                size="sm"
                variant="danger"
                @click="deleteReservation(row.item)"
              >
               <feather-icon size="14" icon="TrashIcon" />
              </b-button>
  
            </div>
          </template>
  
          <template #cell(product_category)="data">
            <div v-html="formatProduct(data.item.product_category, 'primary')"></div>
          </template>
          <template #cell(product_name)="data">
            <div v-html="formatProduct(data.item.product_name, 'warning')"></div>
          </template>
          <template #cell(createdat)="reservationRequest">
            <div>
              {{
                reservationRequest.item.createdat
                  ? $moment(reservationRequest.item.createdat).format('dddd, Do MMMM YYYY')
                  : '-'
              }}
            </div>
          </template>
          <template #cell(request_status)="data">
            <div v-if="activeTab === 'DELETE'">
              <b-button variant="danger" class="badge badge-primary">DELETED</b-button>
            </div>
            <div v-else>
              {{ data.item.request_status }}
            </div>
          </template>
  
        </b-table>
      </div>
      <!-- Mobile screen -->
      <div class="d-flex d-md-none flex-column">
        <!-- Loading -->
        <div v-if="isBusy" class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
          <strong class="text-secondary">Loading...</strong>
        </div>
        <!-- Data -->
        <div v-if="!isBusy && filteredReservations.length == 0" class="text-center text-danger my-2">
          <strong class="text-secondary">No data</strong>
        </div>
        <b-row
          v-if="!isBusy && filteredReservations.length > 0"
          v-for="(item, index) in filteredReservations"
          :key="item.id"
          class="mb-3 list-item"
        >
          <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
            <strong class="flex-grow-1 truncate">{{ item.project_name || '-' }}</strong>
            <div v-if="activeTab !== 'DELETE'">
              <b-button
                type="button"
                class="mr-1 txt-xs-2"
                size="sm"
                variant="secondary"
                @click="SetStatus(item)"
              >
                <feather-icon size="14" icon="BookIcon" />
              </b-button>
              <b-button
                type="button"
                class="mr-1 txt-xs-2"
                size="sm"
                variant="danger"
                @click="deleteReservation(item)"
              >
               <feather-icon size="14" icon="TrashIcon" />
              </b-button>
            </div>
          </b-col>
          <b-col cols="12" class="d-flex flex-wrap">
            <div style="font-size: 0.75rem;">
              <p><strong>CUSTOMER: </strong>{{ item.customer_name || '-' }}</p>
              <p><strong>PROJECT STATUS: </strong>{{ item.project_status || '-' }}</p>
              <p>
                <strong>PORTFOLIO: </strong>
                <div v-html="formatProduct(item.product_category, 'primary')"></div>
              </p>
              <p>
                <strong>PRODUCT NAME: </strong>
                <div v-html="formatProduct(item.product_name, 'warning')"></div>
              </p>
              <p><strong>DATE: </strong>{{ item.date || '-' }}</p>
              <p><strong>TIME: </strong>{{ item.time || '-' }}</p>
              <p>
                <strong>REQUEST STATUS: </strong>
                <template v-if="activeTab === 'DELETE'">
                  <b-button variant="danger" class="badge badge-primary">DELETED</b-button>
                </template>
                <template v-else>
                  {{ item.request_status || '-' }}
                </template>
              </p>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">
              Showing {{ pagination.from }} to {{ pagination.to }} of
              {{ pagination.total }} entries
            </span>
          </b-col>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="pagination.total"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="changePage"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
      <b-modal
        title="Action Reservation Request"
        hide-footer
        id="reservation-set-status"
        size="lg"
        centered
        hide-header-close
      >
        <b-form @submit="onSubmit">
          <b-row>
            <b-col md="12" >
              <b-row>
                <b-col md="12">
                  <h5 class="text-center mb-2"> Detail Reservation  </h5>
                </b-col>
                <!-- AM Name + NIK -->
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      AM Name <span class="text-danger">*</span>
                    </template>
                    <b-form-input v-model="detail_am_name" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      NIK <span class="text-danger">*</span>
                    </template>
                    <b-form-input v-model="detail_nik" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
    
                <!-- Segment/Witel + Division/TREG -->
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      Segment <span class="text-danger">*</span>
                    </template>
                    <b-form-input v-model="detail_segmen_witel" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      Division/TREG <span class="text-danger">*</span>
                    </template>
                    <b-form-input v-model="detail_division_treg" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
    
                <!-- Phone Number + Email -->
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      Phone Number <span class="text-danger">*</span>
                    </template>
                    <b-form-input type="tel" v-model="detail_phone_number" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      Email <span class="text-danger">*</span>
                    </template>
                    <b-form-input type="email" v-model="detail_email" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
    
                <!-- Project Name -->
                <b-col md="12">
                  <b-form-group>
                    <template #label>
                      Project Name <span class="text-danger">*</span>
                    </template>
                    <b-form-input v-model="detail_project_name" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
    
                <!-- Customer Name + Project Status -->
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      Customer Name <span class="text-danger">*</span>
                    </template>
                    <b-form-input v-model="detail_customer_name" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      Project Status <span class="text-danger">*</span>
                    </template>
                    <b-form-input v-model="detail_project_status" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
    
                <!-- Date + Time -->
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      Date <span class="text-danger">*</span>
                    </template>
                    <b-form-input v-model="detail_date" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      Time <span class="text-danger">*</span>
                    </template>
                    <b-form-input v-model="detail_time" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
    
                <!-- Product Category + Product Name -->
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      Portfolio <span class="text-danger">*</span>
                    </template>
                    <b-form-input v-model="detail_product_category" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      Product Name <span class="text-danger">*</span>
                    </template>
                    <b-form-input v-model="detail_product_name" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
    
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      Portfolio II
                    </template>
                    <b-form-input v-model="detail_product_category2"  placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <template #label>
                      Product Name II
                    </template>
                    <b-form-input v-model="detail_product_name2" placeholder="Ex. " disabled required />
                  </b-form-group>
                </b-col>
    
                <!-- Notes -->
                <b-col md="12">
                  <b-form-group label="Notes">
                    <b-form-textarea v-model="detail_note" placeholder="Ex. " rows="3" disabled />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="12">
              <hr>
              <h5 class="text-center mb-2"> Response Reservation  </h5>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <template #label>
                  Status <span class="text-danger">*</span>
                </template>
                <b-form-select
                  v-model="form.request_status"
                  id="request_status"
                  :options="['APPROVED', 'RESCHEDULE']"
                  :disabled="validationStatus"
                  @change="handleApproveNoteChange"
                />
              </b-form-group>
              <b-form-group v-if="isActiveApproveNote && form.request_status === 'APPROVED' && (activeTab === 'APPROVED' || activeTab === 'ALL')">
                <template #label>
                 Approved Note <span class="text-danger">*</span>
                </template>
                <b-form-select
                  v-model="form.approve_note"
                  id="approve_note"
                  :options="approveNoteOptions"
                  :disabled="validationStatus"
                />
              </b-form-group>
  
            </b-col>
            <b-col md="12 mb-1 mt-1" v-if="form.request_status === 'RESCHEDULE'">
              <div class="d-flex justify-content-between align-items-center w-100">
                <b-form-checkbox
                  v-model="validationToogle"
                  switch
                  class="mb-0"
                  @change="onToggle"
                  :disabled="validationStatus"
                >
                Just change the selected time
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col md="6" v-if="form.request_status === 'RESCHEDULE'">
              <b-form-group invalid-feedback="Date is required for reschedule.">
                <template #label>
                  Date <span class="text-danger">*</span>
                </template>
                <b-form-datepicker v-model="form.date" id="date" class="w-100" :date-disabled-fn="isDateDisabled" :min="today" :disabled="validationStatus || validationToogle" required />
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="form.request_status === 'RESCHEDULE'">
              <b-form-group>
                <template #label>
                  Time <span class="text-danger">*</span>
                </template>
                <b-form-select
                  v-model="form.time"
                  id="time"
                  :options="timeOptions"
                  :required="form.request_status === 'RESCHEDULE'"
                  :disabled="validationStatus"
                />
              </b-form-group>
            </b-col>
            <b-col md="12" v-if="hiddenNote">
              <b-form-group label="Notes">
                <b-form-textarea
                  v-model="form.notes"
                  id="notes"
                  placeholder="Ex. "
                  rows="3"
                  :disabled="validationStatus"
                />
              </b-form-group>
            </b-col>
            <b-col class="d-flex justify-content-end">
              <b-button
                variant="primary"
                class="d-inline-flex align-items-center mr-1"
                @click="$bvModal.hide('reservation-set-status')"
              >
                <span>Cancel</span>
              </b-button>
              <b-button v-if="!validationStatus"
                variant="primary" type="submit" :disabled="isLoading">Submit</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
    </b-card>
  </b-container>
</template>

<script>
import {
  BSpinner,
  BCard,
  BRow,
  BCol,
  BTable,
  BFormCheckbox,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BPagination,
  BModal,
  VBModal,
  BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import Ripple from 'vue-ripple-directive'
import moment from "moment";
import * as XLSX from 'xlsx';
import { generateToken } from '@/auth/helperAuth'
import DateRangeCard from './dashboard/dateRangeCard.vue'
import * as Services from './dashboard/services'
import AdditionalInfo from './dashboard/additionalInfo.vue'
import TopDivision from './dashboard/topDivision.vue'
import TopProduct from './dashboard/topProduct.vue'
import TopProjectStatus from './dashboard/topProjectStatus.vue'

export default {
  components: {
    BSpinner,
    BCard,
    BRow,
    BCol,
    BTable,
    BFormCheckbox,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BPagination,
    BModal,
    VBModal,
    BFormTextarea,
    vSelect,
    BFormSelect,
    BFormDatepicker,
    DatePicker,
    moment,
    DateRangeCard,
    TopDivision,
    TopProduct,
    TopProjectStatus,
    AdditionalInfo
  },
  data() {
    const { dateFrom: from, dateTo: to } = Services
    return {
      date: {
        from,
        to,
      },
      countDocument: '',
      topDivision: '',
      topProduct: '',
      topProjectStatus: '',
      loadingDashboard: true,
      token: "",
      validationToogle: false,
      isLoading: false,
      detail_am_name: '',
      detail_customer_name: '',
      detail_division_treg: '',
      detail_email: '',
      detail_date: '',
      detail_nik: '',
      detail_note: '',
      detail_phone_number: '',
      detail_product_category: '',
      detail_product_name: '',
      detail_product_category2: '',
      detail_product_name2: '',
      detail_project_name: '',
      detail_project_status: '',
      detail_segmen_witel: '',
      detail_time: '',
      form: {
        id: 0,
        request_status: '',
        approve_note: '',
        date: null,
        time: '',
        notes: '',
      },
      approveNoteOptions: [],
      usedDates: [],
      today: new Date().toISOString().split('T')[0],
      validationStatus: false,
      hiddenNote: false,
      dateTouched: false,
      productNames: [],
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      totalAll: 0,
      sortBy: 'createdat',
      sortDesc: true,
      perPageOptions: [10, 20, 30],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      times: [
        { value: '09.00 - 10.00 WIB', start: 9 },
        { value: '10.00 - 11.00 WIB', start: 10 },
        { value: '13.00 - 14.00 WIB', start: 13 },
        { value: '14.00 - 15.00 WIB', start: 14 },
        { value: '15.00 - 16.00 WIB', start: 15 },
      ],
      isActiveApproveNote: true,
      reservationRequest: [],
      searchWord: '',
      statuses: [
        { label: 'All', value: 'ALL' },
        { label: 'Requested', value: 'REQUESTED' },
        { label: 'Approved', value: 'APPROVED' },
        { label: 'Reschedule', value: 'RESCHEDULE' },
        { label: 'Delete', value: 'DELETE' },
      ],
      currentStatus: 'ALL',
      activeTab: 'ALL',
    }
  },

  directives: {
    Ripple,
  },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    };
    this.token = generateToken(payload)
    this.LoadDashboard()
  },
  mounted() {
    console.log('approveNoteOptions in mounted:', this.approveNoteOptions);
    console.log('form.approve_note in mounted:', this.form.approve_note);

    this.activeTab = this.$route.query.status || 'ALL';
    this.currentStatus = this.activeTab;
    // this.fetchreservationRequest();
    this.fetchUsedDates();
  },
  watch: {
      // Tambah: biar sync dari router tab status
      // '$route.query.status'(newStatus) {
      //   this.activeTab = newStatus || 'ALL';
      //   this.currentStatus = this.activeTab;
      //   this.fetchreservationRequest();
      // },
      perPage() { this.fetchreservationRequest(); },
      currentPage() { this.fetchreservationRequest(); },
      searchWord() { this.fetchreservationRequest(); },
      'form.request_status'(val) {
        if (val !== 'RESCHEDULE') {
          this.form.date = null;
          this.form.time = null;
        }
      },
    },
  computed: {
      timeOptions() {
        const now = new Date()
        const currentHour = now.getHours()

        return this.times.map(slot => {
          // default false
          let disabled = false

          // cek kalau tanggal dipilih = hari ini
          if (this.form.date) {
            const selectedDate = new Date(this.form.date)
            const today = new Date()

            // bandingkan tanggal tanpa jam
            if (
              selectedDate.getFullYear() === today.getFullYear() &&
              selectedDate.getMonth() === today.getMonth() &&
              selectedDate.getDate() === today.getDate()
            ) {
              if (slot.start <= currentHour) {
                disabled = true
              }
            }
          }

          return {
            value: slot.value,
            text:  slot.value,
            disabled
          }
        })
      },
      filteredReservations() {
        return this.reservationRequest;
      },
      tableFields() {
        const baseFields = [
          { key: 'project_name', label: 'Project Name', sortable: true },
          { key: 'customer_name', label: 'Customer', sortable: true },
          { key: 'project_status', label: 'Project Status', sortable: true },
          { key: 'product_category', label: 'Portfolio', sortable: true },
          { key: 'product_name', label: 'Product Name', sortable: true },
          { key: 'date', label: 'Date', sortable: true },
          { key: 'time', label: 'Time', sortable: true },
          // {
          //   key: 'createdat',
          //   formatter: (value) => this.$moment(value).format('YYYY-MM-DD H:mm'),
          //   label: 'Time',
          //   sortable: true,
          // },
          { key: 'request_status', label: 'Request Status', sortable: true },
        ];
        if (this.activeTab !== 'DELETE') {
          baseFields.push('action');
        }
        return baseFields;
      }

  },
  filters: {
    truncate: function(value, length, start = 0) {
      if (!value) return ''
      value = value.toString().replace(/<[^>]*>?/gm, '');
      if (value.length > length) {
        if (start > 0) {
          return value.substring(start, length + start) + '...'
        } else {
          return value.substring(start, length) + '...'
        }
      } else {
        return value
      }
    },
  },

  watch: {
    '$route.query.status'(newStatus) {
      this.syncTabFromRoute();
      this.fetchreservationRequest();
    },
    perPage() { this.fetchreservationRequest(); },
    currentPage() { this.fetchreservationRequest(); },
    searchWord() { this.fetchreservationRequest(); },
    'form.request_status'(val) {
      if (val !== 'RESCHEDULE') {
        this.form.date = null;
        this.form.time = null;
      }
    },
    'form.date'() {
      this.form.time = ''
    }
  },

  mounted() {
    this.syncTabFromRoute();
    // this.fetchreservationRequest()
    this.fetchUsedDates();
  },

  methods: {
    onToggle() {
      this.form.time = ''
      if(this.validationToogle) {
        this.form.date = this.detail_date
      } else {
        this.form.date = null
      }
    },
    handleApproveNoteChange(selectedValue) {
      if(selectedValue === 'APPROVED'){
        if (this.activeTab === 'ALL'){
          this.isActiveApproveNote = false
        }else{
          this.isActiveApproveNote = true
        }
        // this.isActiveApproveNote = true
      }else{
        this.isActiveApproveNote = false
      }
    },
    onSubmit(event) {
      event.preventDefault()
      this.dateTouched = true;
      console.log("Form data:", this.form);

      const requestData = {
        id: this.form.id,
        request_status: this.form.request_status,
      }
      if (this.form.request_status === 'RESCHEDULE') {
        requestData.date_rescheduled_to = this.form.date
        requestData.time_rescheduled_to = this.form.time
        requestData.reschedule_note = this.form.notes
        requestData.approve_note = null
      }else{
        requestData.date_rescheduled_to = null
        requestData.time_rescheduled_to = null
        requestData.reschedule_note = null
        requestData.approve_note = this.form.notes
      }

      this.isLoading = true
      // this.$http.put(`${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling/updateStatus`, requestData, {
      this.$http.put(`${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling/updateStatus`, requestData, {
        headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
      }).then(() => {
        this.$notif('Success', 'Request has been successfully updated.', 'success')
        window.location.reload()
      }).catch(err => {
        console.error('Fetch failed:', err);
        this.reservationRequest = [];
      })
    },

    syncTabFromRoute() {
      const routeStatus = this.$route.query.status || 'ALL';
      this.activeTab = routeStatus;
      this.currentStatus = routeStatus;
    },
    filterByStatus(status) {
      if (this.$route.query.status !== status) {
        this.$router.push({ query: { status } });
      } else {
        // Paksa sync ulang jika klik status yg sama
        this.syncTabFromRoute();
        this.fetchreservationRequest();
      }
    },
    fetchreservationRequest() {
      this.isBusy = true;
      const params = {
        currentPage: this.currentPage,
        perPage: this.perPage,
        sortBy: 'createdat',
        sortDir: this.sortDesc === true ? 'desc' : 'asc',
        search: this.searchWord.trim(),
        startDate: this.date.from.value,
        endDate: this.date.to.value,
      };
      if (this.activeTab && this.activeTab !== 'ALL') {
        params.request_status = this.activeTab;
      }
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling`, {
        params,
        withCredentials: true,
        headers: {
          'Client-Device': 'browser',
          'Authorization': `${this.token}`,
          'Accept': 'application/json'
        },
      })
        .then(({ data }) => {
          this.reservationRequest = data.data;
          this.pagination.total = data.pagination.total;
          this.pagination.from = data.pagination.from;
          this.pagination.to = data.pagination.to;
          this.totalAll = data.pagination.total;
          this.currentPage = data.pagination.current_page;
        })
        .catch(err => {
          console.error('Fetch failed:', err);
          this.reservationRequest = [];
        })
        .finally(() => {
          this.isBusy = false;
        });
    },    
    fetchUsedDates() {
      // this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling/dateTime`, {
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling/dateTime`, {
        withCredentials: true,
        headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
      })
        .then((data) => {
          const response = data.data
          this.usedDates = [
            ...new Set(
              response
                .map(item => item.date)
                .filter(date => /^\d{4}-\d{2}-\d{2}$/.test(date)) // hanya format valid
            )
          ];
        })
        .catch(error => {
          this.$notif('Error', `${error.data.message}`, 'error')
        })
    },
    isDateDisabled(ymd, date) {
      return this.usedDates.includes(ymd); // ymd dalam format YYYY-MM-DD
    },

    ExportDashboard(){
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling/dashboard?startDate=${this.date.from.value}&endDate=${this.date.to.value}`, {
        withCredentials: true,
        headers: {
          'Client-Device': 'browser',
          'Authorization': `${this.token}`,
          'Accept': 'application/json'
        },
      })
        .then(({ data }) => {
          const workbook = XLSX.utils.book_new();
          
          // Additional Information
          const valueAdditionalInformation = [[data.data.summary.total_reservation, data.data.summary.requested, data.data.summary.approved, data.data.summary.reschedule]]
          const worksheetDataAdditionalInfo = [['Total Reservation', 'Requested', 'Approved', 'Rescheduled'], ...valueAdditionalInformation];
          const worksheetAdditionalInfo = XLSX.utils.aoa_to_sheet(worksheetDataAdditionalInfo);
          XLSX.utils.book_append_sheet(workbook, worksheetAdditionalInfo, 'Additional Information');

          // Top
          const top5Division = []
          const top5Product = []
          const top5ProjectStatus = []
          for (let index = 0; index < 5; index++) {
            top5Division.push([
              (index+1),
              data.data.topDivision[index] ?  data.data.topDivision[index].division_treg : '-',
              data.data.topDivision[index] ?  data.data.topDivision[index].count : '-',
            ])
            top5Product.push([
              (index+1),
              data.data.topProduct[index] ? data.data.topProduct[index].product_name : '-',
              data.data.topProduct[index] ? data.data.topProduct[index].count : '-'
            ])
            top5ProjectStatus.push([
              (index+1),
              data.data.projectStatus[index] ? data.data.projectStatus[index].project_status : '-',
              data.data.projectStatus[index] ? data.data.projectStatus[index].count : '-'
            ])
          }
          const worksheetData = [['No', 'Top 5 Division', 'Total'], ...top5Division];
          const worksheetDivision = XLSX.utils.aoa_to_sheet(worksheetData);
          XLSX.utils.book_append_sheet(workbook, worksheetDivision, 'Top 5 Division');

          const worksheetData2 = [['No', 'Top 5 Product', 'Total'], ...top5Product];
          const worksheetProduct = XLSX.utils.aoa_to_sheet(worksheetData2);
          XLSX.utils.book_append_sheet(workbook, worksheetProduct, 'Top 5 Product');

          const worksheetData3 = [['No', 'Project Status', 'Total'], ...top5ProjectStatus];
          const worksheetProjectStatus = XLSX.utils.aoa_to_sheet(worksheetData3);
          XLSX.utils.book_append_sheet(workbook, worksheetProjectStatus, 'Project Status');

          XLSX.writeFile(workbook, 'Data Dashboard Reservation Request.xlsx');
        })
        .catch(err => {
          console.error('Fetch failed:', err)
          this.loadingDashboard = false
        })
        .finally(() => {
          this.loadingDashboard = false
        });
    },

    fetchreservationRequest() {
      this.isBusy = true;

      const isDeletedTab = this.activeTab === 'DELETE';
      const baseUrl = isDeletedTab
        ? `${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling/deletedData`
        : `${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling`;

      const params = {
        currentPage: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDir: this.sortDesc ? 'desc' : 'asc',
        startDate: this.date.from.value,
        endDate: this.date.to.value,
        search: this.searchWord.toString().trim(),
        ...(this.activeTab && this.activeTab !== 'ALL' ? { request_status: this.activeTab } : {})
      };

      this.$http
        .get(baseUrl, {
          params,
          withCredentials: true,
          headers: {
            accept: 'application/json',
            'Client-Device': 'browser',
            Authorization: `${this.token}`,
          },
        })
        .then(({ data }) => {
          this.reservationRequest = data.data || [];

          if (isDeletedTab) {
            // jika deletedData tidak punya pagination
            this.totalAll = data.pagination.total;
            this.currentPage = data.pagination.current_page;
            this.pagination = {
              total: data.pagination.total,
              from: data.pagination.from,
              to: data.pagination.to,
            };
          } else {
            // default dari endpoint utama
            this.totalAll = data.pagination.total;
            this.currentPage = data.pagination.current_page;
            this.pagination = {
              total: data.pagination.total,
              from: data.pagination.from,
              to: data.pagination.to,
            };
          }
        })
        .catch((err) => {
          console.error('Fetch failed:', err);
          this.reservationRequest = [];
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
      deleteReservation(item) {
        const id = item.id;
        const projectName = item.project_name;
        const url = `${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling/${id}/softDelete`;

        this.$bvModal.msgBoxConfirm(
          `Are you sure you want to delete reservation ID ${projectName}?`,
          {
            title: 'Confirm Delete',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Yes',
            cancelTitle: 'No',
            footerClass: 'p-2',
            centered: true
          }
        ).then((confirmed) => {
          if (confirmed) {
            this.isBusy = true;
            
            this.$http.put(url, {}, {
              headers: {
                'Authorization': `${this.token}`,
                'Accept': 'application/json'
              }
            })
            .then((response) => {
              this.$bvToast.toast('Reservation deleted successfully.', {
                title: 'Deleted',
                variant: 'success',
                solid: true
              });
              this.fetchreservationRequest(); // Refresh list
            })
            .catch((error) => {
              console.error(error);
              this.$bvToast.toast('Failed to delete reservation.', {
                title: 'Error',
                variant: 'danger',
                solid: true
              });
            })
            .finally(() => {
              this.isBusy = false;
            });
          }
        });
      },
    changePage(page) {
      this.currentPage = page
    },
    sortingChanged({ sortBy, sortDesc}) {
      // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
      // ctx.sortDesc ==> true if sorting descending, false otherwise
      if (sortBy !== '') {
        this.sortBy = sortBy
        this.sortDesc = sortDesc
        this.fetchreservationRequest()
      }
    },
    formatProduct(value, color) {
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          return parsed
            .map(
              (cat) =>
                `<span class="badge badge-${color}" style="margin-right: 4px">${cat}</span>`
            )
            .join('');
        }
      } catch (e) {
        return `<span class="badge badge-${color}">${value}</span>`;
      }
    },
    DetailFormater(value, type) {
      try {
        const parsed = JSON.parse(value);
        if (parsed.length === 1) {
          if (type === 'category') {
            this.detail_product_category = parsed[0]
            this.detail_product_category2 = ""
          } else {
            this.detail_product_name = parsed[0]
            this.detail_product_name2 = ""
          }
        } else {
          if (type === 'category') {
            this.detail_product_category = parsed[0]
            this.detail_product_category2 = parsed[1]
          } else {
            this.detail_product_name = parsed[0]
            this.detail_product_name2 = parsed[1]
          }
        }
      } catch (e) {
        if (type === 'product') {
          this.detail_product_name = value
        } else {
          this.detail_product_category = value
        }
      }
    },
    SetStatus(item) {
      console.log('masuk')
      console.log(item)
      this.isActiveApproveNote = true
      this.approveNoteOptions = item.approve_note ? [item.approve_note] : [];
      if(item.request_status === 'REQUESTED'){
        this.validationStatus = false
      }else{
        this.validationStatus = true
      }
      this.form.approve_note = item.approve_note ? item.approve_note : '';

      if(item.request_status !== 'APPROVED'){
        this.hiddenNote = true
      }else{
        this.hiddenNote = false
      }
      this.form.id = item.id ? item.id : ''
      this.form.request_status = item.request_status ? item.request_status : ''
      this.form.date = item.date_rescheduled_to ? item.date_rescheduled_to : null
      this.form.time = item.time_rescheduled_to ? item.time_rescheduled_to : ''
      this.$nextTick(() => {
        document.getElementById("time").value = item.time_rescheduled_to
      })
      let noteP = ''
      if(item.request_status === 'APPROVED') {
        noteP = item.approve_note
      }else{
        noteP = item.reschedule_note
      }
      this.form.notes = noteP
      this.detail_am_name = item.am_name ? item.am_name : ""
      this.detail_customer_name = item.customer_name ? item.customer_name : ""
      this.detail_division_treg = item.division_treg ? item.division_treg : ""
      this.detail_email = item.email ? item.email : ""
      this.detail_date = item.date ? item.date : ""
      this.detail_nik = item.nik ? item.nik : ""
      this.detail_note = item.note ? item.note : ""
      this.detail_phone_number = item.phone_number ? item.phone_number : ""
      this.DetailFormater(item.product_category, 'category')
      this.DetailFormater(item.product_name, 'product')
      this.detail_project_name = item.project_name ? item.project_name : ""
      this.detail_project_status = item.project_status ? item.project_status : ""
      this.detail_segmen_witel = item.segmen_witel ? item.segmen_witel : ""
      this.detail_time = item.time ? item.time : ""
      this.$bvModal.show('reservation-set-status')
    },
    LoadDashboard(){
      this.loadingDashboard = true
      this.fetchreservationRequest()
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling/dashboard?startDate=${this.date.from.value}&endDate=${this.date.to.value}`, {
        withCredentials: true,
        headers: {
          'Client-Device': 'browser',
          'Authorization': `${this.token}`,
          'Accept': 'application/json'
        },
      })
        .then(({ data }) => {
          this.countDocument = {
            total_reservation: data.data.summary.total_reservation,
            requested: data.data.summary.requested,
            approved: data.data.summary.approved,
            reschedule: data.data.summary.reschedule,
          }
          const topDivision = []
          const topProduct = []
          const topProjectStatus = []
          for (let index = 0; index < 5; index++) {
            topDivision.push({
              name: data.data.topDivision[index] ?  data.data.topDivision[index].division_treg : '-',
              total: data.data.topDivision[index] ?  data.data.topDivision[index].count : '-',
            })
            topProduct.push({
              name: data.data.topProduct[index] ? data.data.topProduct[index].product_name : '-',
              total: data.data.topProduct[index] ? data.data.topProduct[index].count : '-',
            })
            topProjectStatus.push({
              name: data.data.projectStatus[index] ? data.data.projectStatus[index].project_status : '-',
              total: data.data.projectStatus[index] ? data.data.projectStatus[index].count : '-',
            })
          }
          // console.log(topDivision)
          // console.log(topProduct)
          // console.log(topProjectStatus)
          this.topDivision = topDivision
          this.topProduct = topProduct
          this.topProjectStatus = topProjectStatus
        })
        .catch(err => {
          console.error('Fetch failed:', err)
          this.loadingDashboard = false
        })
        .finally(() => {
          this.loadingDashboard = false
        });
    },
ExportExcel() {
  const url = this.currentStatus === "DELETE" ? "/consultativeSelling/deletedData" : "/consultativeSelling"
  this.$http
    .get(`${process.env.VUE_APP_API_HELPER_URL}${url}`, {
      params: {
        currentPage: 0,
        perPage: this.totalAll,
        sort: 'desc',
        request_status: this.currentStatus === "ALL" ? '' : this.currentStatus, 
        startDate: this.date.from.value,
        endDate: this.date.to.value
      },
      withCredentials: true,
      headers: {
        'Client-Device': 'browser',
        'Authorization': `${this.token}`,
      },
    })
    .then(({ data }) => {
      const headers = [
        'NIK', 
        'AM Name', 
        'Segment', 
        'Divisi / TREG', 
        'Phone Number', 
        'Email', 
        'Project Name', 
        'Customer Name',
        'Project Status',
        'Date',
        'Time',
        'Portfolio',
        'Product Name',
        'Notes',
        'Request Status',
        'Created At',
      ];

      const rows = data.data.map(item => [
        item.nik,
        item.am_name,
        item.segmen_witel,
        item.division_treg,
        item.phone_number,
        item.email,
        item.project_name,
        item.customer_name,
        item.project_status,
        item.date,
        item.time,
        this.parseArray(item.product_category),
        this.parseArray(item.product_name),
        item.note,
        item.request_status,
        this.$moment(item.createdat).format('dddd, Do MMMM YYYY')
      ]);
      const worksheetData = [headers, ...rows];
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'ConsultativeSelling');
      XLSX.writeFile(workbook, 'consultative-selling.xlsx');
    })
    .catch(error => {
      console.error('Error saat export Excel:', error);
    })
    .finally(() => {
      this.isBusy = false;
    });
},

parseArray(arrayString) {
  try {
    const array = JSON.parse(arrayString);
    return array.join(', '); 
  } catch (e) {
    return arrayString;
  }
}
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
/* Bungkus utama dropdown */
.per-page-selector .vs__dropdown-toggle {
  max-width: 50px;
  height: 36px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Container isi selected */
.per-page-selector .vs__selected-options {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

/* Elemen teks angka (misalnya 10) */
.per-page-selector .vs__selected {
  font-size: 14px;
  line-height: 1;
  margin: 0;
  padding: 0 0 0 12px; /* ⬅️ ini geser ke kanan */
  display: inline-block;
  transform: translateY(12px); /* ⬅️ geser ke bawah */
}


</style>
